import React, { useState } from 'react';
import Button from '../../../Button';
import { useAuth } from '../../AuthContextProvider';
import * as SocialIcons from './Icons';

const SocialAuthView: React.FC = () => {
  const { actions, config } = useAuth();
  const providers = config.socialProviders;

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState('');

  const handleProviderSignIn = async (provider: string) => {
    setLoading(true);

    try {
      await actions.socialLoginRegister(provider);
    } catch (error) {
      setError('error');
    }
    setLoading(false);
  };

  return (
    <>
      {providers && providers.length > 0 && (
        <React.Fragment>
          <div className="flex flex-col items-center justify-center mt-10 border-t border-gray-600 pt-10">
            <div className="font-light text-sm text-gray-400">
              or continue with
            </div>
            <div className="grid gap-4 grid-cols-2 mt-3 w-full">
              {providers.map((provider) => {
                // @ts-ignore
                const AuthIcon = SocialIcons[provider];
                return (
                  <div key={provider} className="my-4">
                    <Button
                      type="button"
                      loading={loading}
                      text={
                        <>
                          <AuthIcon />{' '}
                          <span className="capitalize block ml-2 font-medium">
                            {provider}
                          </span>
                        </>
                      }
                      buttonStyle="white"
                      onClick={() => handleProviderSignIn(provider)}
                    />
                  </div>
                );
              })}
            </div>
          </div>

          {error && (
            <p className="my-4 text-red-700 text-xs font-medium">
              Failed to login using the selected method, please try another or
              contact support.
            </p>
          )}
        </React.Fragment>
      )}
    </>
  );
};

export default SocialAuthView;
